<script setup>
// Libraries
import { useBrowserListener } from '@/composables/browser/listeners'
import { useAnnouncementStore } from '@/stores/announcement';

// Composables
import { setCookie } from '@/composables/helpers/client-only/cookies';

// Instantiate store
const announcementStore = useAnnouncementStore();

// Variables
const banner = ref(null);
const showing = ref(true);

const startClosed = useCookie('startAnnouncementClosed');
const announcement = computed(() => {
    return announcementStore.announcementHtml;
});

// Logic
const close = () => {
    if (process.server) return;
    // console.info('Closing announcement');
    showing.value = !showing.value;
    setCookie('startAnnouncementClosed', true, 1);
};

if (startClosed.value) showing.value = false;

const setHeight = () => {
    if (process.server) return; 
    if (banner.value && showing.value) {
        document.documentElement.style.setProperty('--announcement-height', `${banner.value.offsetHeight}px`);
    } else {
        document.documentElement.style.setProperty('--announcement-height', `0px`);
    }
};

watch(showing, () => {
    nextTick(() => setHeight());
});

useBrowserListener('resize', () => {
    if (process.server) return;
    setHeight();
});

onMounted(() => { setHeight(); });

</script>
<template>
    <section class="global-announcement" :class="{ collapsed: !showing }" v-if="announcement" ref="banner" role="region">
        <div class="container">
            <div class="caps">
                <MessHtml :html="announcement" />
            </div>
            <button type="button" aria-label="Close announcement banner" @click.prevent="close">
                <span class="sr-only">Close announcement banner</span>
                <MessSvg type="X" />
            </button>
        </div>
    </section>
</template>

<style lang="scss">
.global-announcement {
    background: var(--orange);
    padding: 1.25rem 0;
    transition: 350ms ease;
    position: relative;
    z-index: 10;

    &.collapsed {
        max-height: 0;
        overflow: hidden;
        padding: 0;
    }

    .container {
        position: relative;
        color: white;
        text-align: center;
        padding: 0 1.5rem;
        transition: 350ms ease;

        a {
            color: white;
            --hover-color: white;
            border-bottom: 1px solid white;

            &:hover {
                color: var(--hover-color);
                border-bottom: 1px solid transparent;
            }
        }

        button {
            @include basic-hover;
            
            position: absolute;
            top: 50%;
            right: 0;
            translate: (0 -50%);
            width: 0.75rem;
            height: 0.75rem;

            .mess-svg {
                @include absolute-center;
                path {
                    fill: white;
                }
            }
        }
    }
}
</style>
